import createAxiosInstance from './axiosConfig';
import { Cessao } from '../shared/model/cessao';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/cessaoController');

export default class CessaoService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarCessaoPorId(numeroCessao: string) {
    return await this.axios.get(`/listarCessaoPorId?id=${numeroCessao}`);
  };

  async listarTodasCessoes(page: number = 0, size: number = 10) {
    return await this.axios.get(`/listarTodasCessoes?page=${page}&size=${size}`);
  }

  async incluirAlterarCessao(dto: Cessao) {
    return await this.axios.post(`/incluirAlterarCessao`, dto);
  };

  async envioCessaoMotor(dadosEnvio: string[]) {
    return await this.axios.post(`/envioCessaoMotor`, dadosEnvio);
  }

  async gerarGabarito(idCessao: number) {
    return await this.axios.post(`/gerarGabarito`, { idCessao });
  }

  async enviarGabaritoS3(protocoloRemessa: string) {
    return await this.axios.post(`/enviarGabarito`, { protocoloRemessa });
  }

}